import type { MessageTemplateResponse, UpdateMessageTemplateRequest } from '@/core/generated/api';
import type { MessageTemplateFormValues } from './model/schema';

/** Подготавливает текстовку к редактированию */
export const messageTemplateResponseToFormValues = (
    response: MessageTemplateResponse,
): MessageTemplateFormValues => ({
    text: response.text ?? '',
    description: response.description ?? '',
});

/** Подготавливает изменения текстовки */
export const messageTemplateFormValuesToRequest = (
    values: MessageTemplateFormValues,
    original: MessageTemplateResponse,
): UpdateMessageTemplateRequest => ({
    text: values.text,
    description: values.description || null,
    group: original.group?.id,
    version: original.version,
});
